import "./icon.scss";
export const AuctionIcon = () => {
  return (
    <span className="iconsvg">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        data-icon="pic-center"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        viewBox="64 64 896 896"
      >
        <path d="M521.335 73.375l-21.504 21.5v-0.125l-246.623 246.75 45.25 45.25 21.5-21.5 146.751 146.75-329.376 329.374 45.25 45.252 329.374-329.378 146.752 146.752-21.5 21.5 45.248 45.252 268.126-268.126-45.248-45.252-21.504 21.5-338.748-338.749 21.5-21.5-45.248-45.25zM499.831 185.375l50.752 50.75-134.625 134.625-50.75-50.75 134.623-134.625zM595.831 281.375l146.752 146.751-134.626 134.626-146.748-146.752 134.622-134.625zM787.831 473.374l50.752 50.752-134.626 134.626-50.748-50.752 134.622-134.626z"></path>
      </svg>
    </span>
  );
};

export const BillIcon = () => {
  return (
    <span className="iconsvg">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        data-icon="pic-center"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        viewBox="64 64 896 896"
      >
        <title></title>
        <g id="icomoon-ignore"></g>
        <path d="M192 128v768h640v-768h-640zM256 192h512v640h-512v-640zM320 320v64h384v-64h-384zM320 512v64h224v-64h-224zM608 512v64h96v-64h-96zM320 640v64h224v-64h-224zM608 640v64h96v-64h-96z"></path>
      </svg>
    </span>
  );
};

export const UserLogin = () => {
  return (
    <span className="iconsvg">
      <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Profile">
          <g id="Group 3">
            <mask id="mask0_13104_14709" maskUnits="userSpaceOnUse" x="0" y="11" width="16" height="8">
              <path id="Clip 2" fillRule="evenodd" clipRule="evenodd" d="M0.330078 11.8711H15.6616V18.7863H0.330078V11.8711Z" fill="white" />
            </mask>
            <g mask="url(#mask0_13104_14709)">
              <path
                id="Fill 1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.99679 13.2776C3.87255 13.2776 1.78188 13.9641 1.78188 15.3192C1.78188 16.6865 3.87255 17.3795 7.99679 17.3795C12.1201 17.3795 14.2098 16.693 14.2098 15.3379C14.2098 13.9706 12.1201 13.2776 7.99679 13.2776ZM7.99685 18.7863C6.10072 18.7863 0.330078 18.7863 0.330078 15.3193C0.330078 12.2284 4.70597 11.8711 7.99685 11.8711C9.89297 11.8711 15.6617 11.8711 15.6617 15.3381C15.6617 18.429 11.2868 18.7863 7.99685 18.7863Z"
                fill="white"
              />
            </g>
          </g>
          <g id="Group 6">
            <mask id="mask1_13104_14709" maskUnits="userSpaceOnUse" x="2" y="0" width="12" height="11">
              <path id="Clip 5" fillRule="evenodd" clipRule="evenodd" d="M2.85645 0.152344H13.1356V10.1103H2.85645V0.152344Z" fill="white" />
            </mask>
            <g mask="url(#mask1_13104_14709)">
              <path
                id="Fill 4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.99705 1.49144C5.92477 1.49144 4.23868 3.12412 4.23868 5.13191C4.23191 7.13314 5.90541 8.76489 7.96898 8.77239L7.99705 9.44197V8.77239C10.0684 8.77239 11.7535 7.13877 11.7535 5.13191C11.7535 3.12412 10.0684 1.49144 7.99705 1.49144ZM7.99701 10.1107H7.96604C5.13783 10.1022 2.8468 7.86749 2.85648 5.12916C2.85648 2.38614 5.16202 0.152344 7.99701 0.152344C10.831 0.152344 13.1356 2.38614 13.1356 5.13197C13.1356 7.87781 10.831 10.1107 7.99701 10.1107Z"
                fill="white"
              />
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
};

export const WalletIcon = () => {
  return (
    <span className="iconsvg">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        data-icon="pic-center"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        viewBox="64 64 896 896"
      >
        <title></title>
        <g id="icomoon-ignore"></g>
        <path d="M320 128c-34.978 0-64 29.022-64 64v96h-32c-52.639 0-96 43.361-96 96v416c0 52.638 43.361 96 96 96h576c52.638 0 96-43.362 96-96v-416c0-52.639-43.362-96-96-96h-64v-96c0-34.978-29.022-64-64-64h-352zM320 192h64v96h-64v-96zM480 192h192v96h-192v-96zM224 352h576c18.082 0 32 13.919 32 32v416c0 18.082-13.918 32-32 32h-576c-18.081 0-32-13.918-32-32v-416c0-18.081 13.919-32 32-32zM720 544c-26.496 0-48 21.504-48 48s21.504 48 48 48c26.496 0 48-21.504 48-48s-21.504-48-48-48z"></path>
      </svg>
    </span>
  );
};
export const AccountIcon = () => {
  return (
    <span className="iconsvg">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        data-icon="pic-center"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        viewBox="64 64 896 896"
      >
        <path d="M512 128c-123.375 0-224 100.625-224 224 0 76.625 39 144.623 98 184.998-114.5 48.751-194 162.5-194 295.002h64c0-142.874 113.125-256 256-256s256 113.126 256 256h64c0-132.501-79.501-246.251-194.001-295.002 58.999-40.375 98.001-108.373 98.001-184.998 0-123.375-100.625-224-224-224zM512 192c88.751 0 160 71.25 160 160s-71.249 160-160 160c-88.75 0-160-71.249-160-160s71.25-160 160-160z"></path>
      </svg>
    </span>
  );
};

export const ExitIcon = () => {
  return (
    <span className="iconsvg">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="pic-center" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M430.507 665.173l60.16 60.16 213.333-213.333-213.333-213.333-60.16 60.16 110.080 110.507h-412.587v85.333h412.587l-110.080 110.507zM810.667 128h-597.333c-47.36 0-85.333 38.4-85.333 85.333v170.667h85.333v-170.667h597.333v597.333h-597.333v-170.667h-85.333v170.667c0 46.933 37.973 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-38.4-85.333-85.333-85.333z"></path>
      </svg>
    </span>
  );
};
export const PurchaseIcon = () => {
  return (
    <span className="iconsvg">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="pic-center" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M288 160v448h64v-384h448v512c0 35.75-28.25 64-64 64s-64-28.25-64-64v-96h-512v96c0 70.374 57.625 128 128 128h448c70.374 0 128-57.626 128-128v-576h-576zM416 352v64h64v-64h-64zM544 352v64h192v-64h-192zM416 480v64h64v-64h-64zM544 480v64h192v-64h-192zM224 704h384v32c0 23.501 6.874 45.001 18.001 64h-338.001c-35.75 0-64-28.25-64-64v-32z"></path>
      </svg>
    </span>
  );
};

export const ReceivecashIcon = () => {
  return (
    <span className="iconsvg">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="pic-center" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M544 128c-70.374 0-128 57.625-128 128 0 47.375 26.5 88.875 64.998 111-0.623 5.625-0.998 11.125-0.998 17 0 88 72 160 160 160s160-72 160-160c0-78.375-57.374-144.625-132.002-158-13.5-56.125-63.872-98-123.998-98zM544 192c26.001 0 47.876 15.125 58.001 37-41.877 10.375-77.376 37.75-98.999 74-13.751-11.5-23.002-27.5-23.002-47 0-35.75 28.25-64 64-64zM640 288c53.376 0 96 42.625 96 96s-42.624 96-96 96c-53.376 0-96-42.624-96-96s42.624-96 96-96zM367 512c-102.25 0-238 56-238 56l24 60.002c0 0 137.5-52.002 214-52.002 31 0 83.876 18.999 126.999 40.998 21.5 11.004 40.751 22.502 55.002 32 7.125 4.753 13.124 9.003 16.998 12.002 1.877 1.498 3.251 3.251 4.002 3.998l5.001 7.002c2.5 7.125 1.749 15.125-3.004 21.999-6.123 8.627-16.998 12.002-26.999 9.003h-0.998l-139-67.004-27 58.001 142 68.002h0.998l2.001 0.998c37.001 13.001 78.374 0.124 101.001-32 12.749-18.125 16.499-39.373 13.999-59.998l154.001-26.001c16.998-2.876 32.623 7.748 37.999 24 5.751 17.25-2.372 34.748-18.999 42.001-46.874 20.625-122.249 51.499-189.999 77.001-33.877 12.749-66.249 23.996-90.999 32-12.378 3.998-23.125 6.997-31.002 8.998s-14.251 2.999-10.999 2.999c2.001 0-10.876-2.876-26.001-10.999s-34.125-20.002-52.999-32c-18.875-12.002-38.375-24.124-57-34.001-18.625-9.873-35.375-18.999-58-18.999-52.375 0-99 20.002-99 20.002l25 58.999c0 0 39.125-15.002 74-15.002-0.875 0 12.75 2.876 28 10.999s34.125 20.002 53 32c18.875 12.002 37.75 24.124 56.002 34.001 18.249 9.873 34.249 18.999 56.998 18.999 10.876 0 17.126-2.377 26.999-5.001 9.877-2.624 21.875-5.751 34.999-10.001 26.253-8.499 58.5-19.998 93.001-32.998 68.877-25.873 145.25-56.499 194.001-77.999 46.251-20.378 69.999-74.125 53.999-122.001-15.249-45.751-62.374-73.873-109.999-66.001l-175.002 29.001c-0.124-0.124-0.751 0.124-0.998 0-1.003-0.751-2.001-2.249-2.999-2.999l-9.003-7.002v1.003c-2.748-2.001-4.749-3.874-8-5.999-16.623-11.004-38.246-23.876-61.999-36.002-47.625-24.252-103.5-48-156-48z"></path>
      </svg>
    </span>
  );
};
export const HomeIcon = () => {
  return (
    <span className="iconsvg">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="pic-center" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M602.353 162.033l301.176 271.059v470.438h-120.471v-361.412h-361.412v361.412h-120.471v-470.438l301.176-271.059zM602.353 0l-602.353 542.118h180.706v481.882h361.412v-361.412h120.471v361.412h361.412v-481.882h180.706l-602.353-542.118z"></path>
      </svg>
    </span>
  );
};
export const CloseIcon = () => {
  return (
    <span className="iconsvg">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="pic-center" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M512 0c-283.136 0-512 228.864-512 512s228.864 512 512 512c283.136 0 512-228.864 512-512s-228.864-512-512-512zM512 921.6c-225.792 0-409.6-183.808-409.6-409.6s183.808-409.6 409.6-409.6c225.792 0 409.6 183.808 409.6 409.6s-183.808 409.6-409.6 409.6zM695.808 256l-183.808 183.808-183.808-183.808-72.192 72.192 183.808 183.808-183.808 183.808 72.192 72.192 183.808-183.808 183.808 183.808 72.192-72.192-183.808-183.808 183.808-183.808-72.192-72.192z"></path>
      </svg>
    </span>
  );
};

export const ManagmentIcon = () => {
  return (
    <span className="iconsvg">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="pic-center" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M256 160c-52.639 0-96 43.361-96 96v512c0 52.638 43.361 96 96 96h512c52.638 0 96-43.362 96-96v-512c0-52.639-43.362-96-96-96h-512zM256 224h512c18.082 0 32 13.919 32 32v64h-576v-64c0-18.081 13.919-32 32-32zM224 384h576v96h-576v-96zM224 544h576v96h-224c0 35.733-28.267 64-64 64s-64-28.267-64-64h-224v-96zM224 704h177.937c22.282 37.999 63.129 64 110.063 64s87.782-26.001 110.063-64h177.937v64c0 18.082-13.918 32-32 32h-512c-18.081 0-32-13.918-32-32v-64z"></path>
      </svg>
    </span>
  );
};
export const CloseIconModal = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.0024 0C4.47244 0 0.00244141 4.47 0.00244141 10C0.00244141 15.53 4.47244 20 10.0024 20C15.5324 20 20.0024 15.53 20.0024 10C20.0024 4.47 15.5324 0 10.0024 0ZM10.0024 18C5.59244 18 2.00244 14.41 2.00244 10C2.00244 5.59 5.59244 2 10.0024 2C14.4124 2 18.0024 5.59 18.0024 10C18.0024 14.41 14.4124 18 10.0024 18ZM13.5924 5L10.0024 8.59L6.41244 5L5.00244 6.41L8.59244 10L5.00244 13.59L6.41244 15L10.0024 11.41L13.5924 15L15.0024 13.59L11.4124 10L15.0024 6.41L13.5924 5Z"
        fill="#4D4D4D"
      />
    </svg>
  );
};
